import { PreferencesContext } from "../../contexts/PreferencesContext";




import React, { Component } from 'react';
import { Dropdown, DropdownToggle, DropdownMenu, DropdownItem } from 'reactstrap';
import { withRouter, Redirect, Link } from 'react-router-dom';
import { logout } from '../../actions/AppActions';
import { connect } from 'react-redux';

// users
import moment from 'moment';
import { API_URL, THIS_URL, URL } from '../../variables';
import { maskNumber } from '../../Auxiliar/Masks';

import ReactPaginate from 'react-paginate';
import { MdCheckCircle, MdDownload, MdOpenInNew, MdOutlineRule, MdReply, MdSettings, MdVisibility } from 'react-icons/md';
import { Form, FormControl as Input, InputGroup, Button, Select, Spinner } from "react-bootstrap";
import ImageLoaderInput from '../ReusableComponents/ImageLoaderInput';
import Attention from '../ReusableComponents/Attention';
import { RiArrowGoBackLine } from 'react-icons/ri';
import DefaultButton from '../ReusableComponents/DefaultButton';
import JoditEditor from 'jodit-react';
import TabPanel from "../ReusableComponents/TabPanel";
import ModuleTabChooser from "../ReusableComponents/ModuleTabChooser";
import TextReadMore from '../ReusableComponents/TextReadMore';
import { CircularProgress, Snackbar } from "@material-ui/core";
import Redacoes from '../Redacoes/Redacoes';
import Provas from '../Provas/Provas';
import CandidatosVinculados from '../CandidatosVinculados/CandidatosVinculados';
import FiscaisVinculados from '../FiscaisVinculados/FiscaisVinculados';
import CorretoresVinculados from '../CorretoresVinculados/CorretoresVinculados';
import SalasProcesso from '../SalasProcesso/SalasProcesso';
import QuestoesProva from './QuestoesProva';
import ResultadosProva from './ResultadosProva';
import ProvasModelos from './ProvasModelos';
import './label.css';


class ShowProvasProcesso extends Component {static contextType = PreferencesContext;

  constructor(props) {
    super(props);
    this.state = {
      redirect: false,
      path: '/',
      loading_screen: true,
      roles: [],
      name: '',
      caminho: '',
      termos: '',
      loading_save: false,
      msgErro: '',
      loading_image: false,
      processo: {},
      prova: { questoes: [] },
      show_more: false,

      activeTab: -1
    };

  }


  get_prova_processo(id) {

    if (this.state.loading_screen == false) {
      this.setState({ loading_screen: true });
    }
    fetch(`${URL}api/faculdade/get_prova_processo/${id}`, {
      method: 'GET',
      headers: {
        Accept: 'application/json',
        'Authorization': `Bearer ${this.props.token}`
        // 'Content-Type': 'application/json',
      }
    }).then(async (responseLog) => {
      try {
        let resp = await responseLog.json();
        console.log(resp);
        if (resp.message == "Unauthenticated.") {
          localStorage.removeItem('token');localStorage.removeItem('user');
          // this.setState({redirect:true,path:'/'});
          this.props.logout();
          return;
        }
        if (resp.errors != null || resp.error != null) {
          let errors = Object.values(resp.errors);
          let erro = '';
          for (let i = 0; i < errors.length; i++) {
            if (i != errors.length - 1)
            erro += errors[i] + '\n';else

            erro += errors[i];
          }
          console.log(erro);
          this.setState({ redirect: true });

          //   setTimeout(()=>{
          //     this.get_prova_processo();
          //   });
        } else
        {
          // this.props.mudarUser(resp.user);
          this.setState({
            loading_screen: false, prova: resp.prova, processo: resp.prova.processo
          });
          // if (resp.processo != null) {


        }




      } catch (err) {
        this.setState({ redirect: true });
        console.log(err);


      }

    }).
    catch((err) => {
      this.setState({ redirect: true });

      console.log(err);
      // this.props.mudarLoadingHome(false);
    });
  }






  componentDidMount() {
    let tab = new URLSearchParams(this.props.location.search).get('tab');
    if (tab !== undefined && tab !== null) this.setState({ activeTab: parseInt(tab) });else
    if (tab === null) this.setState({ activeTab: -1 });
    this.get_prova_processo(this.props.match.params.id);
  }

  renderBooleanBadge(value) {
    const enabled = value === true || value === 1 || value === '1';
    return (
      <span className={`exam-option-badge ${enabled ? 'is-success' : 'is-danger'}`}>
        {enabled ? this.context.t("answer_yes") : this.context.t("answer_no")}
      </span>
    );
  }

  renderTextBadge(value, tone = 'neutral') {
    return (
      <span className={`exam-option-badge is-${tone}`}>
        {this.renderValue(value)}
      </span>
    );
  }

  renderValue(value) {
    if (value === true || value === 1 || value === '1') {
      return this.context.t("answer_yes");
    }
    if (value === false || value === 0 || value === '0') {
      return this.context.t("answer_no");
    }
    if (value === null || value === undefined || value === '') {
      return '-';
    }
    return value;
  }

  getExamTypeLabel() {
    if (this.state.prova.type == 'dissertativa') {
      return this.context.t("legacy_prova_dissertativa") || 'Prova dissertativa';
    }
    return this.context.t("legacy_prova_objetiva");
  }

  getFinalVisibilityLabel() {
    const prova = this.state.prova || {};
    if (prova.mirror == true) {
      if (prova.show_acertos == true) {
        return this.context.t("form_finished_result_exam_booklet_candidate");
      }
      return this.context.t("form_finished_result_exam_booklet_correct");
    }
    if (prova.folha_resposta == true && prova.show_acertos == true) {
      return this.context.t("form_finished_result_answer_and_accuracy");
    }
    if (prova.folha_resposta == true) {
      return this.context.t("form_finished_result_answer_sheet");
    }
    if (prova.show_acertos == true) {
      return this.context.t("form_finished_result_accuracy_sheet");
    }
    return this.context.t("form_finished_result_none");
  }

  getFinalVisibilityTone() {
    const prova = this.state.prova || {};
    if (prova.mirror == true || prova.folha_resposta == true || prova.show_acertos == true) {
      return 'success';
    }
    return 'neutral';
  }

  getDownloadOptions() {
    const prova = this.state.prova || {};
    const options = [];
    if (prova.folha_resposta == true) {
      options.push({
        label: this.context.t("form_allow_download_answer_sheet"),
        enabled: prova.allow_download_answer_sheet == true,
      });
    }
    if (prova.show_acertos == true && prova.mirror != true) {
      options.push({
        label: prova.folha_resposta == true ? this.context.t("form_allow_download_answer_and_accuracy_sheet") : this.context.t("form_allow_download_accuracy_sheet"),
        enabled: prova.allow_download_accuracy_sheet == true,
      });
    }
    if (prova.mirror == true) {
      options.push({
        label: this.context.t("form_allow_download_mirror"),
        enabled: prova.allow_download_mirror == true,
      });
    }
    return options;
  }

  formatDateTime(value) {
    return value ? moment(value).format('DD/MM/YYYY HH:mm') : '-';
  }

  renderOptionItem(label, value, type = 'text') {
    return (
      <div className="exam-option-item">
        <span>{label}</span>
        {type == 'boolean' ? this.renderBooleanBadge(value) : type == 'custom' ? value : <strong>{this.renderValue(value)}</strong>}
      </div>
    );
  }

  renderDownloadOptions() {
    const options = this.getDownloadOptions();
    if (options.length == 0) {
      return (
        <div className="exam-option-download-empty">
          {this.context.t("exam_options_no_downloads")}
        </div>
      );
    }
    return (
      <div className="exam-option-download-list">
        {options.map((option, index) => (
          <div className="exam-option-download-row" key={index}>
            <span>{option.label}</span>
            {this.renderBooleanBadge(option.enabled)}
          </div>
        ))}
      </div>
    );
  }

  renderExamOptionsSummary() {
    const prova = this.state.prova || {};
    const processo = this.state.processo || {};
    const hasResultPeriod = prova.show_result_start_at || prova.show_result_end_at;
    const hasRandomModels = prova.random_layouts_max == true;
    const hasOneQuestion = prova.one_question_per_page == true;

    return (
      <section className="exam-options-summary">
        <div className="exam-options-summary-header">
          <div>
            <span className="exam-options-eyebrow">{this.context.t("exam_options_summary_eyebrow")}</span>
            <h5>{this.context.t("exam_options_summary_title")}</h5>
            <p>{this.context.t("exam_options_summary_description")}</p>
          </div>
        </div>

        <div className="exam-options-grid">
          <div className="exam-option-card">
            <div className="exam-option-card-title">
              <MdSettings />
              <strong>{this.context.t("exam_options_basic")}</strong>
            </div>
            {this.renderOptionItem(this.context.t("legacy_tipo"), this.renderTextBadge(this.getExamTypeLabel(), 'neutral'), 'custom')}
            {this.renderOptionItem(this.context.t("exam_options_exam_time"), prova.time ? `${prova.time} min` : '-')}
            {this.renderOptionItem(this.context.t("legacy_numero_de_questoes"), prova.questoes?.length || 0)}
          </div>

          <div className="exam-option-card">
            <div className="exam-option-card-title">
              <MdCheckCircle />
              <strong>{this.context.t("exam_options_randomization")}</strong>
            </div>
            {this.renderOptionItem(this.context.t("exam_options_use_exam_models"), prova.random_layouts_max, 'boolean')}
            {hasRandomModels && this.renderOptionItem(this.context.t("exam_options_exam_models_count"), prova.number_exams || prova.provas?.length || '-')}
            {this.renderOptionItem(this.context.t("exam_options_shuffle_questions"), prova.aleatorizar_questoes, 'boolean')}
            {this.renderOptionItem(this.context.t("exam_options_shuffle_alternatives"), prova.aleatorizar_alternativas, 'boolean')}
            {this.renderOptionItem(this.context.t("exam_options_select_from_group"), prova.select_from_group, 'boolean')}
            {this.renderOptionItem(this.context.t("exam_options_random_by_subject"), prova.random_per_category, 'boolean')}
          </div>

          <div className="exam-option-card">
            <div className="exam-option-card-title">
              <MdVisibility />
              <strong>{this.context.t("exam_options_candidate_view")}</strong>
            </div>
            {this.renderOptionItem(this.context.t("ui_exibicao_das_questoes_8463a65b"), hasOneQuestion ? this.context.t("exam_options_one_question") : this.context.t("exam_options_all_questions"))}
            {this.renderOptionItem(this.context.t("form_show_answer_map_question"), prova.show_answer_map !== false && prova.show_answer_map !== 0 && prova.show_answer_map !== '0', 'boolean')}
            {hasOneQuestion && this.renderOptionItem(this.context.t("ui_o_candidato_podera_retornar_para_a_questao_anterio_9d388b4d"), prova.block_return == true ? this.context.t("answer_no") : this.context.t("answer_yes"))}
            {hasOneQuestion && prova.block_return == true && this.renderOptionItem(this.context.t("form_auto_advance_on_answer_question"), prova.auto_advance_on_answer, 'boolean')}
            {this.renderOptionItem(this.context.t("exam_options_block_return_after_pause"), prova.block_return_after_pause, 'boolean')}
            {processo.exam_per_time == true && this.renderOptionItem(this.context.t("ui_tempo_por_questao_eaffb704"), prova.time_per_question ? `${prova.time_per_question} min` : '-')}
          </div>

          <div className="exam-option-card">
            <div className="exam-option-card-title">
              <MdDownload />
              <strong>{this.context.t("settings_results")}</strong>
            </div>
            {this.renderOptionItem(this.context.t("form_finished_result_visibility"), this.renderTextBadge(this.getFinalVisibilityLabel(), this.getFinalVisibilityTone()), 'custom')}
            {this.renderOptionItem(this.context.t("form_finished_result_period"), hasResultPeriod ? `${this.formatDateTime(prova.show_result_start_at)} - ${this.formatDateTime(prova.show_result_end_at)}` : this.context.t("exam_options_immediate_display"))}
            <div className="exam-option-downloads">
              <span>{this.context.t("form_finished_result_downloads")}</span>
              {this.renderDownloadOptions()}
            </div>
          </div>
        </div>
      </section>
    );
  }







  render() {
    if (this.state.loading_screen) return <SkeletonCoursePage />;else
    return (
      <div style={{ position: "relative" }}>
                <div className="card">
                    <div className="card-body">
                        <div style={{ float: 'right' }}>
                            <DefaultButton
                bg="secondary"
                text={this.context.t("back")}
                icon={<RiArrowGoBackLine />}
                search={'?tab=1'}
                to={`/processos/show/${this.state.processo.id}`} />

                        </div>
                        <div className="flex jcsb">
                            <h4 className="header">{this.state.prova.name}</h4>
                        </div>
                        <p className="page-subtitle">{this.context.t("description_show_exam_page")}</p>
                        <div className="section-action-row">
                            <a target="_blank" rel="noreferrer" href={THIS_URL + 'prova/' + this.state.prova.uuid} className="external-preview-link">
                                <MdOpenInNew />
                                {this.context.t("action_view_exam_external")}
                            </a>
                        </div>
                        {this.renderExamOptionsSummary()}


                        {/* <p className="ver_regras" onClick={() => {
              this.setState({ show_more: true })
              }} style={{ float: "left", marginRight: "2px" }}> <b style={{ float: "left", marginRight: "2px", color: 'black', marginRight: 2 }}>Enunciado: </b> <MdOutlineRule /> {'Ver Enunciado'} </p>
              <ModalRedacao showModal={this.state.show_more} setShowModal={(e) => this.setState({ show_more: e })} prova_name={this.state.prova.name} regras={this.state.prova.enunciado} /> */}

                        {/* <div style={{ width: "100%", marginBottom: 10, whiteSpace: 'pre',height:this.state.show_more==false?100:'fit-content',overflowY:this.state.show_more==false? 'hidden':'visible' }}>
              <b style={{ float: "left", marginRight: "2px" }}>{'Regras:'} </b>
              <br/>
              <div className="jodit-wysiwyg" dangerouslySetInnerHTML={{ __html: this.state.processo.regras }}>
              </div>
              </div> */}
                        {/* <div className="w100 flex align-center fdcolumn margin-bottom">
              <div className="course-banner" style={{
              backgroundImage: `url(${STORAGE_URL+ this.state.faculdade.logo})`,
              backgroundSize: "contain",
              backgroundRepeat:'no-repeat',
              backgroundPositionX:'center',
              width: "100%",
              height: "200px",
              borderRadius: "7px"
              }} />
              </div> */}
                        <br />
                        <br />

                        <ModuleTabChooser
              activeTab={this.state.activeTab}
              modules={[
              { id: 0, title: this.context.t("questions"), description: this.context.t("legacy_visualize_e_organize_as_questoes_da_prova") },
              this.state.prova?.processo?.online == true && { id: 1, title: this.context.t("settings_results"), description: this.context.t("description_exam_results") }]
              }
              onSelect={(value) => {
                this.setState({ activeTab: value });
                this.props.history.push({ search: `?tab=${value}` });
              }}
              onBack={() => {
                this.setState({ activeTab: -1 });
                this.props.history.push({ search: '' });
              }} />

                        <TabPanel value={this.state.activeTab} index={0} padding={0}>
                            <h5 className="tab-section-title">{this.context.t("questions")}</h5>
                            {this.state.prova.random_layouts_max == false && <QuestoesProva prova_name={this.state.prova.name} questoes={this.state.prova.questoes} processo_name={this.state.processo.name} />}
                            {this.state.prova.random_layouts_max == true && <ProvasModelos provas={this.state.prova.provas} prova_name={this.state.prova.name} processo_name={this.state.processo.name} questoes={this.state.prova.questoes} />}
                        </TabPanel>
                        {this.state.prova?.processo?.online == true && <TabPanel value={this.state.activeTab} index={1} padding={0}>
                            <h5 className="tab-section-title">{this.context.t("settings_results")}</h5>
                            {/* <Corretores faculdade_id={this.state.faculdade.id} faculdade_name={this.state.faculdade.name} /> */}
                            <ResultadosProva prova={this.state.prova} models={this.state.prova.provas.map((item, id2) => {return { id: item.id, name: this.context.t("legacy_modelo") + item.code_exam };})} processo_name={this.state.processo.name} processo_id={this.state.processo.id} prova_name={this.state.prova.name} prova_id={this.state.prova.id} prova_type={this.state.prova.type} />

                        </TabPanel>}

                    </div>
                </div>

            </div>);

  }


}
const mapsStateToProps = (state) => (
{
  token: state.AppReducer.token
});


const SkeletonCoursePage = () => {
  return (
    <div className="card">
            <div className="card-body">
                <div className="skeleton-title" />
                {/* <div className="skeleton-small-text skeleton-shimmer"/>
          <div className="skeleton-small-text skeleton-shimmer"/> */}
                <br />
                <div className="w100 flex jcc align-center">
                    <div className="skeleton-base skeleton-shimmer" style={{ width: "12em", height: "12em" }} />
                </div>
                <br />
                <div className="w100 skeleton-base skeleton-shimmer margin-bottom" style={{ minHeight: "48px" }} />
                <div className="w100 skeleton-base skeleton-shimmer margin-bottom" style={{ minHeight: "5em" }} />
                <div className="skeleton-small-button skeleton-shimmer" />
            </div>
        </div>);

};

export default connect(mapsStateToProps, { logout })(ShowProvasProcesso);
